import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../../common.service';
import * as FileSaver from 'file-saver';
import * as moment from 'moment';
import * as XLSX from 'xlsx';
import { BrowserModule } from '@angular/platform-browser';
declare let swal:any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $: any;
@Component({
  selector: 'app-rottweiler-dogs-animalmanagement',
  templateUrl: './rottweiler-dogs-animalmanagement.component.html',
  styleUrls: ['./rottweiler-dogs-animalmanagement.component.css']
})
export class RottweilerDogsAnimalmanagementComponent implements OnInit {
  adddisease="/dashboard/AddAnimalDisease";
  samepagerouteanimal="/dashboard/animalmanagement"
  addvaccine="/dashboard/AddAnimalVaccine";
  addsamples="/dashboard/AddAnimalSamples";
  adddiagnostic="/dashboard/AddAnimalDiagnostic";
  adddeworming="/dashboard/AddAnimalDeworming";
  adddeath="/dashboard/AddAnimalDeath";
  addgeneral="/dashboard/AddAnimalGeneral";
  samepageroute="/dashboard/RottweilerDogsAnimalmanagement";
  diseaseviewurl="/dashboard/ViewAnimalDisease";
  diseaseediturl="/dashboard/EditAnimalDisease";
  vaccineviewurl="/dashboard/ViewAnimalVaccine";
  vaccineediturl="/dashboard/EditAnimalVaccine";
  samplesviewurl="/dashboard/ViewAnimalSamples";
  samplesediturl="/dashboard/EditAnimalSamples";
  diagnosticviewurl="/dashboard/ViewAnimalDiagnostic";
  diagnosticediturl="/dashboard/EditAnimalDiagnostic";
  dewormingviewurl="/dashboard/ViewAnimalDeworming";
  dewormingediturl="/dashboard/EditAnimalDeworming";
  deathviewurl="/dashboard/ViewAnimalDeath";
  deathediturl="/dashboard/EditAnimalDeath";
  generalviewurl="/dashboard/ViewAnimalGeneral";
  back="/dashboard/animalmanagement"
  generalediturl="/dashboard/editstockmanagement";
  isLoading=false;
  getlistApi:any;
  user_id:any;
  vaccineListData:any;
  samplesListData:any;
  getstockmanagementListData:any=[];
  DiagnosticListData:any;
  DewormingListData:any;
  GeneralListData:any=[];
  backurl:any;
  addUrl:any;
  DeathListData:any;
  exceldublicatfunarrdeath:any=[];
  getdiseaseListdisease:any=[];
  vaccineadd:any=false;
  diseaseadd:any=false;
  samplesadd:any=false;
  diagnosticadd:any=false;
  dewormingadd:any=false;
  deathadd:any=false;
  generaladd:any=false;
  AnimalListID:any;
  animalidhead:any;
  getdewormingListData:any=[];
  animalid:any;
  isDisabled:boolean=false;
  animalidheadpre:any;
  diseaseListData:any;
  getvaccineListData:any=[];
  exceldublicatfunarrgeneral:any=[];
  userrole:any;
  topheadset:boolean=false;
  loginresponse:any
  farm_userrole:any;
  exceldublicatfunarr:any=[];
  listanimaliduniquecheck:any=[];
  table:any;
  breedgetlistApi:any;
  listbatchno:any=[];
  getgenerallistdata:any=[];
  getfarmsListData:any=[];
  getspeciesListData:any=[];
  getbreedListData:any=[];
  farmcodeforvalidation:any;
  getdeathlistdata:any=[];
  exceldublicatfunarrtable:any=[];
  getvaccinelistdatatable:any=[];
  getdiseaselistdatatable:any=[];
  getdeworminglistdatatable:any=[];
  dataString:any;
  listspeciesname:any=[]; 
  listbreedname:any=[];
   listfarmname:any=[];
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit(){ 
 
    $('.selectpicker').selectpicker('refresh');
        this.AnimalGeneral()
        this.animalidhead=sessionStorage.getItem('animalid');

}

private showUploadSuccessAndReturn(data: any, route: string = this.samepagerouteanimal) {
  alert(data.message);
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
    this.router.navigate([route]);
  });
}

/*getanimalid(){

  this.animalidhead=sessionStorage.getItem('animalid');
  let currentUrl = this.samepageroute;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
    });   
}*/
///Vaccine crud operation start...........................
async animalvaccine(){
  this.vaccineadd=true;
  this.diseaseadd=false;
  this.samplesadd=false;
  this.dewormingadd=false;
  this.diagnosticadd=false;
  this.deathadd=false;
  this.generaladd=false;
  this.isLoading =true;
var table;

 this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
   this.topheadset=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  /* if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
 this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/

  var animalid=sessionStorage.getItem('animalid');

   this.getlistApi= "/animal_management/vaccine/?animal_id="+animalid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
  }, 500);
       $(function(){
       table = $("#myTable1").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
       this.vaccineListData=res.data;
       }) 
     $('.speciessearch').on( 'keyup', function () {
   var inputValue =$(".speciessearch").val();
 
   table.search( inputValue ).draw();
});

}
AddAnimalVaccine(){
  this.router.navigate([this.addvaccine]);
}
viewAnimalVaccine(e){
  console.log(e.target.id);
  sessionStorage.setItem('vaccineId',e.target.id);
  this.router.navigate([this.vaccineviewurl]);
}
editAnimalVaccine(e){
  console.log(e.target.id);
  sessionStorage.setItem('vaccineId',e.target.id);
  this.router.navigate([this.vaccineediturl]);
}
Vaccinesweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal Vaccine record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/vaccine/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal Vaccine record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal Vaccine record has not been deleted',  
        'error' 
      )  
    }  
  })  }

///Vaccine crud operation end...........................
///disease crud operation start...........................
async animaldisease(){
  this.samplesadd=false;
  this.diseaseadd=true;
  this.vaccineadd=false;
  this.diagnosticadd=false;
  this.dewormingadd=false;
  this.deathadd=false;
  this.generaladd=false;
  this.isLoading =true;
  var table;
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  /*if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/

  var animalid=sessionStorage.getItem('animalid')

   this.getlistApi= "/animal_management/disease/?animal_id="+animalid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
        this.topheadset=false;
  }, 500);
       $(function(){
       table = $("#myTable2").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
        this.diseaseListData = res.data; 
       console.log(this.diseaseListData);
       }) 
       $('.speciessearch').on( 'keyup', function () {
        var inputValue =$(".speciessearch").val();
   
        table.search( inputValue ).draw();
     });
}
AddAnimalDisease(){
  this.router.navigate([this.adddisease]);
}
viewAnimalDisease(e){
  console.log(e.target.id);
  sessionStorage.setItem('diseaseId',e.target.id);
  this.router.navigate([this.diseaseviewurl]);
}
editAnimalDisease(e){
  console.log(e.target.id);
  sessionStorage.setItem('diseaseId',e.target.id);
  this.router.navigate([this.diseaseediturl]);
}
backtomastermodule(){
this.router.navigate([this.backurl]);
}
Diseasesweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal Disease record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/disease/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal Disease record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal Disease record has not been deleted',  
        'error' 
      )  
    }  
  })  }

///disease crud operation end...........................
//samples crud operation start...........................
async animalsamples(){
  this.diseaseadd=false;
  this.vaccineadd=false;
  this.samplesadd=true;
  this.diagnosticadd=false;
  this.dewormingadd=false;
  this.deathadd=false;
  this.generaladd=false;
  this.isLoading =true;
  var table;
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
   this.topheadset=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  /*if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/

  var animalid=sessionStorage.getItem('animalid')

   this.getlistApi= "/animal_management/sample/?animal_id="+animalid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
  }, 500);
       $(function(){
       table = $("#myTable3").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
        this.samplesListData = res.data;   
                         
       }) 
       $('.speciessearch').on( 'keyup', function () {
        var inputValue =$(".speciessearch").val();
      
        table.search( inputValue ).draw();
     });
}
AddAnimalSamples(){
  this.router.navigate([this.addsamples]);
}
viewAnimalsamples(e){
  console.log(e.target.id);
  sessionStorage.setItem('samplesId',e.target.id);
  this.router.navigate([this.samplesviewurl]);
}
editAnimalsamples(e){
  console.log(e.target.id);
  sessionStorage.setItem('samplesId',e.target.id);
  this.router.navigate([this.samplesediturl]);
}

Samplessweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal Samples record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/sample/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal Samples record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal Samples record has not been deleted',  
        'error' 
      )  
    }  
  })  

}
//samples crud operation end...........................
//Diagnostic crud operation start...........................
async AnimalDiagnostic(){
  this.diseaseadd=false;
  this.vaccineadd=false;
  this.samplesadd=false;
  this.diagnosticadd=true;
  this.dewormingadd=false;
  this.generaladd=false;
  this.deathadd=false;
  this.isLoading =true;
  var table;
this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
   this.topheadset=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
    /*if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/
  var animalid=sessionStorage.getItem('animalid')
   this.getlistApi= "/animal_management/diagnostics/?animal_id="+animalid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
  }, 500);
       $(function(){
       table = $("#myTable4").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
        this.DiagnosticListData = res.data;   
                         
       }) 
       $('.speciessearch').on( 'keyup', function () {
        var inputValue =$(".speciessearch").val();
    
        table.search( inputValue ).draw();
     });
}
AddAnimalDiagnostic(){
  this.router.navigate([this.adddiagnostic]);
}
viewAnimaldiagnostic(e){
  console.log(e.target.id);
  sessionStorage.setItem('diagnosticId',e.target.id);
  this.router.navigate([this.diagnosticviewurl]);
}
editAnimaldiagnostic(e){
  console.log(e.target.id);
  sessionStorage.setItem('diagnosticId',e.target.id);
  this.router.navigate([this.diagnosticediturl]);
}

Diagnosticsweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal Diagnostic record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/diagnostics/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal Diagnostic record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal Diagnostic record has not been deleted',  
        'error' 
      )  
    }  
  })  

}
//Diagnostic crud operation end...........................
//Deworming crud operation start...........................
async AnimalDeworming(){
  this.diseaseadd=false;
  this.vaccineadd=false;
  this.samplesadd=false;
  this.diagnosticadd=false;
  this.dewormingadd=true;
  this.deathadd=false;
  this.generaladd=false;
  this.isLoading =true;
  var table;
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
   this.topheadset=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
 /* if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/
  var animalid=sessionStorage.getItem('animalid');
   this.getlistApi= "/animal_management/deworming/?animal_id="+animalid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
  }, 500);
       $(function(){
       table = $("#myTable5").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
        this.DewormingListData = res.data;   
                         
       }) 
       $('.speciessearch').on( 'keyup', function () {
        var inputValue =$(".speciessearch").val();
      
        table.search( inputValue ).draw();
     });
}
AddAnimalDeworming(){
  this.router.navigate([this.adddeworming]);
}
viewAnimaldeworming(e){
  console.log(e.target.id);
  sessionStorage.setItem('dewormingId',e.target.id);
  this.router.navigate([this.dewormingviewurl]);
}
editAnimaldeworming(e){
  console.log(e.target.id);
  sessionStorage.setItem('dewormingId',e.target.id);
  this.router.navigate([this.dewormingediturl]);
}

Dewormingsweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal Deworming record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/deworming/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal Deworming record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal Deworming record has not been deleted',  
        'error' 
      )  
    }  
  })  

}
//Deworming crud operation end...........................
//Death crud operation start...........................
async AnimalDeath(){
  this.diseaseadd=false;
  this.vaccineadd=false;
  this.samplesadd=false;
  this.diagnosticadd=false;
  this.dewormingadd=false;
  this.deathadd=true;
  this.generaladd=false;
  this.topheadset=false;
  this.isLoading =true;
  var table;
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
   this.topheadset=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
 /* if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/
  var animalid=sessionStorage.getItem('animalid')
  var farmid=sessionStorage.getItem('farmid')
   this.getlistApi= "/animal_management/death/?animal_id="+animalid+"&farm_user="+farmid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
  }, 500);
       $(function(){
       table = $("#myTable6").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
        this.DeathListData = res.data;  
                                
       }) 
       $('.speciessearch').on( 'keyup', function () {
        var inputValue =$(".speciessearch").val();
        
        table.search( inputValue ).draw();
     });
}
AddAnimalDeath(){
  this.router.navigate([this.adddeath]);
}
viewAnimalDeath(e){
  console.log(e.target.id);
  sessionStorage.setItem('deathId',e.target.id);
  this.router.navigate([this.deathviewurl]);
}
editAnimalDeath(e){
  console.log(e.target.id);
  sessionStorage.setItem('deathId',e.target.id);
  this.router.navigate([this.deathediturl]);
}

Deathsweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal Death record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/death/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal Death record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal Death record has not been deleted',  
        'error' 
      )  
    }  
  }) 
}
//Death crud operation end...........................
//general crud operation start----------------------
async AnimalGeneral(){
  this.diseaseadd=false;
  this.vaccineadd=false;
  this.samplesadd=false;
  this.diagnosticadd=false;
  this.dewormingadd=false;
  this.deathadd=false;
  this.topheadset=false;
  this.generaladd=true;
  this.isLoading =true;
   var table;
this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.userrole==1){
   this.isDisabled = true;
   this.topheadset=true;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
    /*if(this.userrole==0){
   this.isDisabled=false;
    // $(".edit").removeAttr("id"); // Element(s) are now enabled.
  }
  this.farm_user=this.farm_userrole;
  if(this.farm_userrole){
   this.getlistApi= "/vaccine/?farm_user="+this.farm_user;
  }
  else{
   this.getlistApi= "/vaccine";
  }*/
  var animalid=sessionStorage.getItem('animalid')
   this.getlistApi= "/animal_management/general/?animal_id="+animalid;
  (await this.commonService.getApi(this.getlistApi)).subscribe(
    res => {
      setTimeout((res)=>{ 
        this.isLoading =false;
  }, 500);
       $(function(){
       table = $("#myTable7").DataTable();
       //moment().format('YYYY-MM-DD')    
       })
        this.GeneralListData = res.data;   
                         
       }) 
       $('.speciessearch').on( 'keyup', function () {
        var inputValue =$(".speciessearch").val();
        table.search( inputValue ).draw();
     });
}
AddAnimalGeneral(){
  this.router.navigate([this.addgeneral]);
}
viewAnimalGeneral(e){
  console.log(e.target.id);
  sessionStorage.setItem('generalId',e.target.id);
  this.router.navigate([this.generalviewurl]);
}
editAnimalGeneral(e){
  /*console.log(e.target.id);
  sessionStorage.setItem('generalId',e.target.id);
  this.router.navigate([this.generalediturl]);*/
  console.log(e.target.id);
  sessionStorage.setItem('StockId',e.target.id);
  this.router.navigate([this.generalediturl]);
}

Generalsweetdelete(e){
  Swal.fire({  
    title: 'Are you sure you want to delete the Animal General record ?',  
    //text: 'You will not be able to recover this file!',  
    icon: 'warning',  
    showCancelButton: true,  
    confirmButtonText: 'Yes',  
    cancelButtonText: 'No'  
  }).then(async(result) => {  
    if (result.value) {  
      console.log(e.target.id);
      var deleteurl = "/animal_management/general/"+e.target.id;
      (await this.commonService.deleteApi(deleteurl)).subscribe(
        res => {
          Swal.fire(  
            'Deleted!',  
            'The Animal General record has been deleted successfully',  
            'success'  
          );
          let currentUrl = this.samepageroute;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
        });     
        })      
    } else if (result.dismiss === Swal.DismissReason.cancel) {  
      Swal.fire(  
        'Cancelled',  
        'The Animal General record has not been deleted',  
        'error' 
      )  
    }  
  }) 
}
//general crud operation end----------------------
backnavigate(){
  this.router.navigate([this.back])
}

  ///upload  data----------------------------------------------------------------
  async stockmanagement(){
    this.getlistApi= "/stock_management";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
          this.getstockmanagementListData =res.data; 
          console.log(this.getstockmanagementListData);                      
         }) 

         this.getlistApi= "/vaccine";
       // this.getlistApi= "/vaccine";
        (await this.commonService.getApi(this.getlistApi)).subscribe(
          res => {
              this.getvaccineListData = res.data;                          
             }) 
             this.getlistApi= "/parasite";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      res => {
          this.getdewormingListData = res.data;                      
         }) 
         // farm list api start
   this.getlistApi= "/farms";
   (await this.commonService.getApi(this.getlistApi)).subscribe(
     (res) => {
         this.getfarmsListData = res.data;
       
        }) 

      // farm list api end
        // species list api start
        this.getlistApi="/species";
        (await this.commonService.getApi(this.getlistApi)).subscribe(
          (res) => {
              this.getspeciesListData = res.data;
            
             }) 
        // species list api end
          // breed list api start
        this.breedgetlistApi="/breeds";
        (await this.commonService.getApi(this.breedgetlistApi)).subscribe(
          (res) => {
              this.getbreedListData = res.data;
            
             }) 
             this.getlistApi= "/disease";
             (await this.commonService.getApi(this.getlistApi)).subscribe(
               res => {
                   this.getdiseaseListdisease = res.data;
                  })   

      //list data for general,death,vaccine,disease,deworming
      this.getlistApi="/animal_management/general/list";
      (await this.commonService.getApi(this.getlistApi)).subscribe(
        res => {
            this.getgenerallistdata = res.data;
           })   

           this.getlistApi="/animal_management/death/list";
           (await this.commonService.getApi(this.getlistApi)).subscribe(
            res => {
                this.getdeathlistdata = res.data;
               }) 

               this.getlistApi="/animal_management/vaccine/list";
               (await this.commonService.getApi(this.getlistApi)).subscribe(
                res => {
                    this.getvaccinelistdatatable = res.data;
                   }) 
                   this.getlistApi="/animal_management/disease/list";
                   (await this.commonService.getApi(this.getlistApi)).subscribe(
                    res => {
                        this.getdiseaselistdatatable = res.data;
                       })
                       this.getlistApi="/animal_management/deworming/list";
                       (await this.commonService.getApi(this.getlistApi)).subscribe(
                        res => {
                            this.getdeworminglistdatatable = res.data;
                           }) 

  }
  //parasite bulk upload start
 
  async importbulkdatafromexcelforDeworming(ev){
   this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.user_id=this.loginresponse.user_id;
    console.log('test');
    console.log(ev);
    var batchnoduplicatecheck=[];
    var deworminganimalcode_dewormingbatchno_tablecheck=[];
    var sweetalert=[];
    console.log(this.getstockmanagementListData);
    for(var i=0;i<this.getstockmanagementListData.length;i++){
         var animalcode=String(this.getstockmanagementListData[i].tnsm_animal_code).trim().toLowerCase();
         this.listanimaliduniquecheck.push(animalcode);
           //batchnoduplicatecheck.push(animalcode);
           console.log(animalcode)
    }
    //vaccine list dataunique start
  /*  var batchnoduplicatecheck=[];
   for(var i=0;i<this.getdewormingListData.length;i++){
         var batchno=String(this.getdewormingListData[i].tnps_batch_no).trim().toLowerCase();
         this.listbatchno.push(batchno);
           batchnoduplicatecheck.push(batchno);
    }

    for(var i=0;i<this.getdeworminglistdatatable.length;i++){
      var deworminganimalcode=String(this.getdeworminglistdatatable[i].tnam_dew_animal_code).trim().toLowerCase();
      var  dewormingbatchno=String(this.getdeworminglistdatatable[i].batch_no).trim().toLowerCase();
      batchnoduplicatecheck.push(dewormingbatchno);
      deworminganimalcode_dewormingbatchno_tablecheck.push(deworminganimalcode+'_'+dewormingbatchno);
       console.log(deworminganimalcode_dewormingbatchno_tablecheck)
 }*/
    //vaccine list dataunique end
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data =reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var uploadexcelarray=Object.values(jsonData)[0];
      this.dataString ={data:uploadexcelarray}
//        let value:any=dataString;
console.log(this.dataString);
      console.log(this.dataString.data);
//      var excelUniquecheck=[];
var animal_codeandbatchnodublicate=[];
var excelanimalcode=[]
var excelbatch=[]
for(var i=0;i<this.dataString.data.length;i++){

  var animal_code = this.dataString.data[i]["Animal code"];

  if(
    animal_code == undefined ||
    animal_code == null ||
    String(animal_code).trim() == ""
  ){
    continue;
  }

  animal_code = String(animal_code).trim().toLowerCase();

  var deworming_type = String(
    this.dataString.data[i]["Batch number"] || ""
  ).trim().toLowerCase();

  animal_codeandbatchnodublicate.push(
    animal_code + '_' + deworming_type
  );

  excelbatch.push(deworming_type);
  excelanimalcode.push(animal_code);
}

//unique animal code check start.................................
      var differentfarmdata = [];
// var difference = [];
console.log(excelanimalcode)
for( var i = 0; i < excelanimalcode.length; i++ ) {
    if( $.inArray( excelanimalcode[i],this.listanimaliduniquecheck ) == -1 ) {
      differentfarmdata.push(excelanimalcode[i]);
      console.log(excelanimalcode[i])
    }
}
console.log(differentfarmdata)
var result ="";
if(differentfarmdata){
  for(var i=0;i<differentfarmdata.length;i++){
  result +=  "AnimalCode '"+differentfarmdata[i]+"' doesn't exist<br>";
  console.log(differentfarmdata);
}
}
if(result){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(result)
}

/*var differentbatchdata = [];
// var difference = [];
console.log(excelbatch)
for( var i = 0; i < excelbatch.length; i++ ) {
    if( $.inArray( excelbatch[i],batchnoduplicatecheck ) == -1 ) {
      differentbatchdata.push(excelbatch[i]);
      console.log(excelbatch[i])
    }
}
//unique animal batch no check start
console.log(differentbatchdata)
var resultbatch ="";
if(differentbatchdata){
  for(var i=0;i<differentbatchdata.length;i++){
  resultbatch +="deworming_type'"+differentbatchdata[i]+"' doesn't exist<br>";
  console.log(differentbatchdata);
}
}
if(resultbatch){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(resultbatch)
}
//unique animal batch no check end

      //dublicate species id entry check in excel with farm id
      this.exceldublicatevaluecheck(animal_codeandbatchnodublicate);
//console.log(uniquerSpeciesformarray);
console.log(this.exceldublicatfunarr);
var result1 = "";
if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
    var getduplicatevalue2=this.exceldublicatfunarr[i].split('_');
   var animalcode=getduplicatevalue2[0];
   var batchnodublicate=getduplicatevalue2[1];
  result1 +="Animal Id '"+animalcode+"' deworming_type '"+batchnodublicate+"' entered multiple times<br>"
  //console.log(this.exceldublicatfunarr);
}

}
if(result1){
  //Swal.fire("Duplicate Values",result1);
  sweetalert.push(result1)
}


//table dublicate value check start

this.exceldublicatevaluecheckintable(animal_codeandbatchnodublicate,deworminganimalcode_dewormingbatchno_tablecheck)
console.log(this.exceldublicatfunarrtable);
var result4 = "";
if(this.exceldublicatfunarrtable){
for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
    var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
  var animalcode=getduplicatevalue[0];
  var batchnumber=getduplicatevalue[1];
result4 +="This '"+animalcode+"' animal code and deworming Type '"+batchnumber+"' already has Deworming details<br>"
}
}
if(result4){
 // Swal.fire("Duplicate Values",result4);
  console.log(result4)
  sweetalert.push(result4)
}*/
//table dublicate value check end

//dublicate species id and breed entry check in list table with farm id end
var finalvalidatevalue='';
for(var i=0;i<sweetalert.length;i++){
  finalvalidatevalue+=sweetalert[i]+"<br>";
}
if(finalvalidatevalue){
  Swal.fire("Duplicate values",finalvalidatevalue);
  let currentUrl = this.samepagerouteanimal;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
}); 
}else{
  var animaldewormingbulkdata=[]
  for(var i=0;i<this.dataString.data.length;i++){
    var obj =this.dataString.data[i];
    Object.assign(obj, {cby:this.user_id});
    Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
    animaldewormingbulkdata.push(obj);
  }
  console.log(animaldewormingbulkdata)
   this.addUrl = "/animal_management/deworming/bulk/creation";
    (await this.commonService.postApi(this.addUrl,animaldewormingbulkdata)).subscribe(
      data => {
          this.showUploadSuccessAndReturn(data);
      });
}
   
   /* this.addUrl = "/species";
  (await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
    data => {
        alert(data.message);
    });*/

     // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
     
    }
    reader.readAsBinaryString(file);
         

  }
  //parasite bulk upload end
  //vaccine bulk upload
  async importbulkdatafromexcelforvaccine(ev){
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.user_id=this.loginresponse.user_id;
    console.log('test');
    console.log(ev);
    var batchnoduplicatecheck=[];
    var sweetalert=[];
    this.listanimaliduniquecheck=[];
    var vaccineanimalcode_vaccinebatchnofor_tablecheck=[];
    console.log(this.getstockmanagementListData);
    for(var i=0;i<this.getstockmanagementListData.length;i++){
         var animalcode=String(this.getstockmanagementListData[i].tnsm_animal_code).trim().toLowerCase();
         this.listanimaliduniquecheck.push(animalcode);
           //batchnoduplicatecheck.push(animalcode);
           console.log(animalcode)
    }
    //vaccine list dataunique start
    /* 
    var batchnoduplicatecheck=[];
    for(var i=0;i<this.getvaccineListData.length;i++){
         var batchno=String(this.getvaccineListData[i].tnvc_batch_number).trim().toLowerCase();
         this.listbatchno.push(batchno);
           batchnoduplicatecheck.push(batchno);
    }
    for(var i=0;i<this.getvaccinelistdatatable.length;i++){
      var vaccineanimalcode=String(this.getvaccinelistdatatable[i].tnam_vac_animal_code).trim().toLowerCase();
      var vaccinebatchno=String(this.getvaccinelistdatatable[i].batch_no).trim().toLowerCase();
      vaccineanimalcode_vaccinebatchnofor_tablecheck.push(vaccineanimalcode+'_'+vaccinebatchno);
       console.log(vaccineanimalcode_vaccinebatchnofor_tablecheck)
 }*/
    //vaccine list dataunique end
    let workBook = null;
    let jsonData = null; 
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data =reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var uploadexcelarray=Object.values(jsonData)[0];
      this.dataString ={data:uploadexcelarray}
//        let value:any=dataString;
console.log(this.dataString);
      console.log(this.dataString.data);
//      var excelUniquecheck=[];
var animal_codeandbatchnodublicate=[];
var excelanimalcode=[]
var excelbatch=[]
      for(var i=0;i<this.dataString.data.length;i++){
        var animal_code=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase()
       var vaccine_name=String( this.dataString.data[i]["Batch Number"]).trim().toLowerCase()
       animal_codeandbatchnodublicate.push(animal_code+'_'+vaccine_name);
        excelbatch.push(vaccine_name);
        excelanimalcode.push(animal_code);
      }

//unique animal code check start.................................
      var differentfarmdata = [];
// var difference = [];
console.log(excelanimalcode)
for( var i = 0; i < excelanimalcode.length; i++ ) {
    if( $.inArray( excelanimalcode[i],this.listanimaliduniquecheck ) == -1 ) {
      differentfarmdata.push(excelanimalcode[i]);
      console.log(excelanimalcode[i])
    }
}
console.log(differentfarmdata)
var result ="";
if(differentfarmdata){
  for(var i=0;i<differentfarmdata.length;i++){
  result += "Animal code '"+differentfarmdata[i]+"' doesn't exist<br>"
  console.log(differentfarmdata);
}
}
if(result){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(result)
}
/*
var differentbatchdata = [];
// var difference = [];
console.log(excelbatch)
for( var i = 0; i < excelbatch.length; i++ ) {
    if( $.inArray( excelbatch[i],this.listbatchno ) == -1 ) {
      differentbatchdata.push(excelbatch[i]);
      console.log(excelbatch[i])
    }
}
//unique animal batch no check start
console.log(differentbatchdata)
var resultbatch ="";
if(differentbatchdata){
  for(var i=0;i<differentbatchdata.length;i++){
  resultbatch += "Vaccine Name '"+differentbatchdata[i]+"' doesn't exist<br>"
  console.log(differentbatchdata);
}
}
if(resultbatch){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(resultbatch)
}
//unique animal batch no check end

      //dublicate species id entry check in excel with farm id
      this.exceldublicatevaluecheck(animal_codeandbatchnodublicate);
//console.log(uniquerSpeciesformarray);
console.log(this.exceldublicatfunarr);
var result1 = "";
if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
    var getduplicatevalue2=this.exceldublicatfunarr[i].split('_');
   var animalcode=getduplicatevalue2[0];
   var batchnodublicate=getduplicatevalue2[1];
  result1 +=  "Animal code '"+animalcode+"' Vaccine Name '"+batchnodublicate+"' entered multiple times<br>"

  //"AnimalCode "+animalcode+"Batch No <br>";
  //console.log(this.exceldublicatfunarr);
}

}
if(result1){
  //Swal.fire("Duplicate Values",result1);
  sweetalert.push(result1)
}
//table dublicate value check start

    this.exceldublicatevaluecheckintable(animal_codeandbatchnodublicate,vaccineanimalcode_vaccinebatchnofor_tablecheck)
    console.log(this.exceldublicatfunarrtable);
    var result4 = "";
    if(this.exceldublicatfunarrtable){
    for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
        var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
      var animalcode=getduplicatevalue[0];
      var batchnumber=getduplicatevalue[1];
    result4 +="This '"+animalcode+"' animal code and vaccine name '"+batchnumber+"' already has vaccine details<br>"
    }
    }
    if(result4){
     // Swal.fire("Duplicate Values",result4);
      console.log(result4)
      sweetalert.push(result4)
    }*/
//table dublicate value check end
var finalvalidatevalue='';
for(var i=0;i<sweetalert.length;i++){
  finalvalidatevalue+=sweetalert[i]+"<br>";
}
if(finalvalidatevalue){
  Swal.fire("Duplicate values",finalvalidatevalue);
  let currentUrl = this.samepagerouteanimal;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
});   
}else{
  var animalvaccinebulkdata=[]
  for(var i=0;i<this.dataString.data.length;i++){
    var obj =this.dataString.data[i];
    Object.assign(obj, {cby:this.user_id});
    Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
    animalvaccinebulkdata.push(obj);
  }
  console.log(animalvaccinebulkdata)
   this.addUrl = "/animal_management/vaccine/bulk/creation";
    (await this.commonService.postApi(this.addUrl,animalvaccinebulkdata)).subscribe(
      data => {
          this.showUploadSuccessAndReturn(data);
      });
}
   
   /* this.addUrl = "/species";
  (await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
    data => {
        alert(data.message);
    });*/

     // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
     
    }
    reader.readAsBinaryString(file);
         

  }
  async importbulkdatafromexcelfordisease(ev){
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.user_id=this.loginresponse.user_id;
    console.log('test');
    console.log(ev);
    var batchnoduplicatecheck=[];
    var diseaseanimalcode_diseasenamecheck_tablecheck=[];
    var uniqcheckdiseasename=[];
    var sweetalert=[];
   /* console.log(this.getdiseaseListdisease);
    for(var i=0;i<this.getdiseaseListdisease.length;i++){
         var diseasename=String(this.getdiseaseListdisease[i].tnds_disease_name).trim().toLowerCase();
         uniqcheckdiseasename.push(diseasename);
           //batchnoduplicatecheck.push(animalcode);
           console.log(diseasename)
    }*/
    console.log(this.getstockmanagementListData);
    for(var i=0;i<this.getstockmanagementListData.length;i++){
         var animalcode=String(this.getstockmanagementListData[i].tnsm_animal_code).trim().toLowerCase();
         this.listanimaliduniquecheck.push(animalcode);
           //batchnoduplicatecheck.push(animalcode);
           console.log(animalcode)
    }
    /*
    for(var i=0;i<this.getdiseaselistdatatable.length;i++){
      var diseaseanimalcode=String(this.getdiseaselistdatatable[i].tnam_dis_animal_code).trim().toLowerCase();
      var diseasenamecheck=String(this.getdiseaselistdatatable[i].disease_name).trim().toLowerCase();
      diseaseanimalcode_diseasenamecheck_tablecheck.push(diseaseanimalcode+'_'+diseasenamecheck);
       console.log(diseaseanimalcode_diseasenamecheck_tablecheck)
 }*/
    //vaccine list dataunique end
    let workBook = null;
    let jsonData = null; 
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data =reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var uploadexcelarray=Object.values(jsonData)[0];
      this.dataString ={data:uploadexcelarray}
//        let value:any=dataString;
console.log(this.dataString);
      console.log(this.dataString.data);
//      var excelUniquecheck=[];
var animal_codeanddiseasedublicate=[];
var excelanimalcode=[]
var exceldiseasename=[]
      for(var i=0;i<this.dataString.data.length;i++){
        var animal_code=String( this.dataString.data[i]["Animal code"]).trim().toLowerCase()
       var diseasename=String( this.dataString.data[i]["Disease name"]).trim().toLowerCase()
       animal_codeanddiseasedublicate.push(animal_code+'_'+diseasename);
        exceldiseasename.push(diseasename);
        excelanimalcode.push(animal_code);
      }

//unique animal code check start.................................
      var differentfarmdata = [];
// var difference = [];
console.log(excelanimalcode)
for( var i = 0; i < excelanimalcode.length; i++ ) {
    if( $.inArray( excelanimalcode[i],this.listanimaliduniquecheck ) == -1 ) {
      differentfarmdata.push(excelanimalcode[i]);
      console.log(excelanimalcode[i])
    }
}
console.log(differentfarmdata)
var result ="";
if(differentfarmdata){
  for(var i=0;i<differentfarmdata.length;i++){
  result +="Animal code '"+differentfarmdata[i]+"' doesn't exist<br>"
  console.log(differentfarmdata);
}
}
if(result){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(result)
}
/*
var differentdiseasedata = [];
// var difference = [];
console.log(exceldiseasename)
for( var i = 0; i < exceldiseasename.length; i++ ) {
    if( $.inArray( exceldiseasename[i],uniqcheckdiseasename ) == -1 ) {
      differentdiseasedata.push(exceldiseasename[i]);
      console.log(exceldiseasename[i])
    }
}
//unique animal batch no check start
console.log(differentdiseasedata)
var resultbatch ="";
if(differentdiseasedata){
  for(var i=0;i<differentdiseasedata.length;i++){
  resultbatch +="Disease Name '"+differentdiseasedata[i]+"' doesn't exist<br>"
  console.log(differentdiseasedata);
}
}
if(resultbatch){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(resultbatch)
}
//unique animal batch no check end

      //dublicate species id entry check in excel with farm id
      this.exceldublicatevaluecheck(animal_codeanddiseasedublicate);
//console.log(uniquerSpeciesformarray);
console.log(this.exceldublicatfunarr);
var result1 = "";
if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
    var getduplicatevalue2=this.exceldublicatfunarr[i].split('_');
   var animalcode=getduplicatevalue2[0];
   var diseasenamedublicate=getduplicatevalue2[1];
  result1 +="Animal Id '"+animalcode+"' Disease Name '"+diseasenamedublicate+"' entered multiple times<br>"

 // 
  //console.log(this.exceldublicatfunarr);
}

}
if(result1){
  //Swal.fire("Duplicate Values",result1);
  sweetalert.push(result1)
}


//table dublicate value check start

this.exceldublicatevaluecheckintable(animal_codeanddiseasedublicate,diseaseanimalcode_diseasenamecheck_tablecheck)
console.log(this.exceldublicatfunarrtable);
var result4 = "";
if(this.exceldublicatfunarrtable){
for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
    var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
  var animalcode=getduplicatevalue[0];
  var disease_name=getduplicatevalue[1];
result4 +="This '"+animalcode+"' animal code and disease name '"+disease_name+"' already has disease details<br>"
}
}
if(result4){
 // Swal.fire("Duplicate Values",result4);
  console.log(result4)
  sweetalert.push(result4)
}*/
//table dublicate value check end
//dublicate species id and breed entry check in list table with farm id end
var finalvalidatevalue='';
for(var i=0;i<sweetalert.length;i++){
  finalvalidatevalue+=sweetalert[i]+"<br>";
}
if(finalvalidatevalue){
  Swal.fire("Duplicate values",finalvalidatevalue);
  let currentUrl = this.samepagerouteanimal;
  this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
});   
}else{
  var animalvaccinebulkdata=[]
  for(var i=0;i<this.dataString.data.length;i++){
    var obj =this.dataString.data[i];
    Object.assign(obj, {cby:this.user_id});
    Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
    animalvaccinebulkdata.push(obj);
  }
  console.log(animalvaccinebulkdata)
   this.addUrl = "/animal_management/disease/bulk/creation";
    (await this.commonService.postApi(this.addUrl,animalvaccinebulkdata)).subscribe(
      data => {
          this.showUploadSuccessAndReturn(data);
      });
}
   
   /* this.addUrl = "/species";
  (await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
    data => {
        alert(data.message);
    });*/

     // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
     
    }
    reader.readAsBinaryString(file);
         

  }
  //vaccine bulk upload end
  async importbulkdatafromexcel(ev,cmmnupload) {
    this.listanimaliduniquecheck = [];
    this.exceldublicatfunarr = [];
    this.exceldublicatfunarrtable = [];
    this.dataString = [];
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.user_id=this.loginresponse.user_id;
    console.log(cmmnupload)
    if(cmmnupload=='Samples'){
      this.addUrl = "/animal_management/sample/bulk/creation";
    }
    else if(cmmnupload=='Diagnostic'){
      this.addUrl = "/animal_management/diagnostics/bulk/creation";
    }
    else if(cmmnupload=='Death'){
      this.addUrl = "/animal_management/death/bulk/creation";
    }
 
    console.log('test');
    console.log(ev);
    var batchnoduplicatecheck=[];
    var deathlistanimalcodetablecheck=[];
    var sweetalert=[];
    console.log(this.getstockmanagementListData);
    for(var i=0;i<this.getstockmanagementListData.length;i++){
         var animalcode=String(this.getstockmanagementListData[i].tnsm_animal_code).trim().toLowerCase();
         this.listanimaliduniquecheck.push(animalcode);
           batchnoduplicatecheck.push(animalcode);
           console.log(animalcode)
    }
    for(var i=0;i<this.getdeathlistdata.length;i++){
      var deathlistanimalcode=String(this.getdeathlistdata[i].tnam_dth_animal_code).trim().toLowerCase();
      deathlistanimalcodetablecheck.push(deathlistanimalcode);
       console.log(deathlistanimalcodetablecheck)
 }
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data =reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var uploadexcelarray=Object.values(jsonData)[0];
      this.dataString ={data:uploadexcelarray}
//        let value:any=dataString;
console.log(this.dataString);
      console.log(this.dataString.data);
//      var excelUniquecheck=[];

var excelanimalcode=[];
var deathvalidateexc=[];
var excelanimalcodefordublicate=[];
     for(var i=0;i<this.dataString.data.length;i++){

        var animal_code = String(
          this.dataString.data[i]["Animal code"] || ""
        ).trim().toLowerCase();

        var rawdate = this.dataString.data[i]["Date of death"];

        let finaldate = '';

        if(!isNaN(rawdate as any)){

          finaldate = moment(
            new Date((Number(rawdate) - 25569) * 86400 * 1000)
          ).format('YYYY-MM-DD');

        }else{

          finaldate = moment(
            rawdate,
            'DD-MM-YYYY'
          ).format('YYYY-MM-DD');
        }

        excelanimalcode.push(animal_code);
        excelanimalcodefordublicate.push(animal_code);

        console.log(finaldate);

        deathvalidateexc.push(finaldate);
      }

//unique animal code check start.................................
      var differentfarmdata = [];
// var difference = [];
console.log(excelanimalcode)
for( var i = 0; i < excelanimalcode.length; i++ ) {
    if( $.inArray( excelanimalcode[i],this.listanimaliduniquecheck ) == -1 ) {
      differentfarmdata.push(excelanimalcode[i]);
      console.log(excelanimalcode[i])
    }
}
console.log(differentfarmdata)
var result ="";
if(differentfarmdata){
  for(var i=0;i<differentfarmdata.length;i++){
  result +="Animal Id '"+differentfarmdata[i]+"' doesn't exist<br>"
  console.log(differentfarmdata);
}
}
if(result){
 // Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(result)
}
//unique animal code check end.................................
      //console.log(excelUniquecheck);
      //dublicate species id entry check in excel with farm id
    /*  this.exceldublicatevaluecheck(excelanimalcode);
//console.log(uniquerSpeciesformarray);
console.log(this.exceldublicatfunarr);
var result1 = "";
if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
   var batchnodublicate=this.exceldublicatfunarr[0];
  result1 +="AnimalCode "+batchnodublicate+"<br>";
  //console.log(this.exceldublicatfunarr);
}

}
if(result1){
  //Swal.fire("Duplicate Values",result1);
  sweetalert.push(result1)
}*/
if(cmmnupload=='Death'){
this.exceldublicatevaluecheck(excelanimalcodefordublicate);
    
console.log(this.exceldublicatfunarr);
var resultanimalid = "";
if(this.exceldublicatfunarr){
for(var i=0;i<this.exceldublicatfunarr.length;i++){
 var getduplicatevalue=this.exceldublicatfunarr[i];
 //var animalid=getduplicatevalue[0];
 resultanimalid += "Animal Id '"+getduplicatevalue+"' entered multiple times<br>"

}

}
if(resultanimalid){
//Swal.fire("Duplicate Values",result2);
console.log(resultanimalid);
sweetalert.push(resultanimalid)
}
//check animal id have values..........................................
   //list animal code dublicate check for general start
   console.log(excelanimalcode)
   this.exceldublicatevaluecheckintable(excelanimalcode,deathlistanimalcodetablecheck)
   console.log(this.exceldublicatfunarrtable);
   var result4 = "";
   if(this.exceldublicatfunarrtable){
   for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
    var getduplicatevaluegeneral=this.exceldublicatfunarrtable[i]
   result4 +="This '"+getduplicatevaluegeneral+"' animal code already has death details<br>"
   }
   }
   if(result4){
    // Swal.fire("Duplicate Values",result4);
     console.log(result4)
     sweetalert.push(result4)
   }
       //list animal code dublicate check for general end

//futurebirthdateset

var futuredeathdate = [];
// var difference = [];
console.log(deathvalidateexc);
for( var i = 0; i <deathvalidateexc.length; i++ ) {
  console.log(deathvalidateexc[i])
 var date1:any=moment(deathvalidateexc[i]).format('YYYY/MM/DD');
var date2:any= moment().format('YYYY/MM/DD');
if(moment(date1).isAfter(date2)) {
  futuredeathdate.push(date1);
} 
}
var result ="";
console.log(futuredeathdate);
if(futuredeathdate){
for(var i=0;i<futuredeathdate.length;i++){
result +="Some of your entries in your recent activity is  invalid!! line number '"+ [i]+2 +"'"
}
}
if(result){
//Swal.fire("Wrong Farm Selection",result);
sweetalert.push(result)
}
//future birth date end
 
}

  

var finalvalidatevalue='';
for(var i=0;i<sweetalert.length;i++){
  finalvalidatevalue+=sweetalert[i]+"<br>";
}
if(finalvalidatevalue){
  Swal.fire("Duplicate values",finalvalidatevalue);
  let currentUrl = this.samepagerouteanimal;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
          }); 
}else{
  var animalvaccinebulkdata=[]
  for(var i=0;i<this.dataString.data.length;i++){
    var obj =this.dataString.data[i];
    Object.assign(obj, {cby:this.user_id});
    Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
    animalvaccinebulkdata.push(obj);
  }
  console.log(animalvaccinebulkdata);
  
    (await this.commonService.postApi(this.addUrl,animalvaccinebulkdata)).subscribe(
      data => {
          this.showUploadSuccessAndReturn(data);
      });
}
   
   /* this.addUrl = "/species";
  (await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
    data => {
        alert(data.message);
    });*/

     // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
     
    }
    reader.readAsBinaryString(file);
         
  }
  async importbulkdatafromexcelforgeneral(ev) {
    
    console.log('test');
    console.log(ev);
    this.getspeciesListData;
    var uniquerSpeciesformarray=[];
    var uniquespeciesarray=[];
    var uniquebreedsarray=[];
    var sweetalert=[];
    var breedfarmname_speciesname_breedname=[];
    var farmname_speciesname_animalid=[];
    var bname_speciesname_aid_fname=[];
    console.log(this.getfarmsListData)
    for(var i=0;i<this.getfarmsListData.length;i++){
      var farmname1=String(this.getfarmsListData[i].tnfr_code).trim().toLowerCase();
        uniquerSpeciesformarray.push(farmname1);
        console.log(uniquerSpeciesformarray)
  }
  for(var i=0;i<this.getspeciesListData.length;i++){
  var speciesname=String(this.getspeciesListData[i].speciesID).trim().toLowerCase();
  uniquespeciesarray.push(speciesname);
    console.log(uniquespeciesarray)
  }
  for(var i=0;i<this.getbreedListData.length;i++){
    var breedname=String(this.getbreedListData[i].breedID).trim().toLowerCase();
    uniquebreedsarray.push(breedname);
      console.log(uniquebreedsarray)
    }
    for(var i=0;i<this.getstockmanagementListData.length;i++){
         var farmname=String(this.getstockmanagementListData [i].farm_code).trim().toLowerCase();
         var speciesname1=String(this.getstockmanagementListData [i].species_code).trim().toLowerCase();
         var breedname1=String(this.getstockmanagementListData [i].breed_code).trim().toLowerCase();
         var animalid=String(this.getstockmanagementListData [i].tnsm_animal_code).trim().toLowerCase();
         this.listspeciesname.push(speciesname1);
         this.listbreedname.push(breedname1);
         this.listfarmname.push(farmname);
         breedfarmname_speciesname_breedname.push(farmname+'_'+speciesname1+'_'+breedname1);
         farmname_speciesname_animalid.push(farmname+'_'+speciesname1+'_'+animalid);
         bname_speciesname_aid_fname.push(farmname+'_'+speciesname1+'_'+breedname1+'_'+animalid)
  console.log(bname_speciesname_aid_fname)
    }
  
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = async (event) => {
      const data =reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      var uploadexcelarray=Object.values(jsonData)[0];
  this.dataString ={data:uploadexcelarray}
  //        let value:any=dataString;
  console.log(this.dataString);
      var excelFnameSnmeBname=[];
      var excelFnameSnameAid=[];
      var excelFnameSnameBnameAId=[];
      var excelfarmuniquename=[];
      var excelspeciesuniquename=[];
      var wrongfarmid=[];
      var excelbreeduniquename=[];
      if(this.farm_userrole){
      for(var i=0;i<this.dataString.data.length;i++){
        if (this.dataString.data[i]["Farm id"].trim().toLowerCase() == this.farmcodeforvalidation.trim().toLowerCase()) {
        var farmnameexcel=String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
        var speciesnameexcel=String(this.dataString.data[i]["Species id"]).trim().toLowerCase()
        var breednameexcel=String(this.dataString.data[i]["Breed id"]).trim().toLowerCase()
        var animalidnameexcel=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase()
        excelFnameSnmeBname.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel);
        excelFnameSnameAid.push(farmnameexcel+'_'+speciesnameexcel+'_'+animalidnameexcel)
        excelFnameSnameBnameAId.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel+'_'+animalidnameexcel);   
         excelfarmuniquename.push(farmnameexcel);
      excelspeciesuniquename.push(speciesnameexcel);
      excelbreeduniquename.push(breednameexcel);
      }
      else{
        wrongfarmid.push(this.dataString.data[i]["Farm id"].trim().toLowerCase())
        console.log( wrongfarmid)
      }
    }
    if(wrongfarmid.length!==0){
      sweetalert.push("Entered Incorrect Farm Id")
    }
    }
    if(!this.farm_userrole){
      for(var i=0;i<this.dataString.data.length;i++){
        var farmnameexcel=String(this.dataString.data[i]["Farm id"]).trim().toLowerCase()
        var speciesnameexcel=String(this.dataString.data[i]["Species id"]).trim().toLowerCase()
        var breednameexcel=String(this.dataString.data[i]["Breed id"]).trim().toLowerCase()
        var animalidnameexcel=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase()
        excelFnameSnmeBname.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel);
        excelFnameSnameAid.push(farmnameexcel+'_'+speciesnameexcel+'_'+animalidnameexcel)
        excelFnameSnameBnameAId.push(farmnameexcel+'_'+speciesnameexcel+'_'+breednameexcel+'_'+animalidnameexcel);   
         excelfarmuniquename.push(farmnameexcel);
      excelspeciesuniquename.push(speciesnameexcel);
      excelbreeduniquename.push(breednameexcel);
      }
    }
      //unique farm check start
          console.log(excelFnameSnameBnameAId)
  var differentfarmdata = [];
  
  // var difference = [];
  for( var i = 0; i < excelfarmuniquename.length; i++ ) {
    if( $.inArray( excelfarmuniquename[i], uniquerSpeciesformarray ) == -1 ) {
      differentfarmdata.push(excelfarmuniquename[i]);
      console.log(differentfarmdata)
    }
  }
  
  var result ="";
  if(differentfarmdata){
  for(var i=0;i<differentfarmdata.length;i++){
  result +="Farm Id '"+differentfarmdata[i]+"' doesn't exist<br>"
  console.log(differentfarmdata);
  }
  }
  if(result){
  //Swal.fire("Wrong Farm Selection",result);
  sweetalert.push(result)
  
  }
  //unique farm check end
  //unique species check start
  var differentspeciesdata=[];
  for( var i = 0; i < excelspeciesuniquename.length; i++ ) {
    if( $.inArray( excelspeciesuniquename[i], uniquespeciesarray ) == -1 ) {
      differentspeciesdata.push(excelspeciesuniquename[i]);
      console.log(differentspeciesdata)
    }
  }
  
  var resultspecies ="";
  if(differentspeciesdata){
  for(var i=0;i<differentspeciesdata.length;i++){
  resultspecies +="Species Id '"+differentspeciesdata[i]+"' doesn't exist<br>"
  console.log(differentspeciesdata);
  }
  }
  if(resultspecies){
  //Swal.fire("Wrong Farm Selection",resultspecies);
  sweetalert.push(resultspecies)
  }
  //unique species check end
  //unique breed check start
  var differentbreeddata=[];
  for( var i = 0; i < excelbreeduniquename.length; i++ ) {
    if( $.inArray( excelbreeduniquename[i], uniquebreedsarray ) == -1 ) {
      differentbreeddata.push(excelbreeduniquename[i]);
    }
  }
  console.log(differentbreeddata)
  var resultbreeds ="";
  if(differentbreeddata){
  for(var i=0;i<differentbreeddata.length;i++){
    resultbreeds +="Breed Id '"+differentbreeddata[i]+"' doesn't exist<br>"
  console.log(differentbreeddata);
  }
  }
  if(resultbreeds){
  //Swal.fire("Wrong Farm Selection",resultbreeds);
  sweetalert.push(resultbreeds)
  }
  //unique breed check end
  //dublicate species,breeds,fname start
      //console.log(excelUniquecheck);
     /* this.exceldublicatevaluecheck(excelFnameSnmeBname)
  console.log(this.exceldublicatfunarr);
  var result1 = "";
  if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
   var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
   var farmnamedublicate=getduplicatevalue[0];
   var speciesnamedublicate=getduplicatevalue[1];
   var breednamedublicate=getduplicatevalue[2];
   //var animaliddublicate=getduplicatevalue[3];
   result1 +="Farm Name "+farmnamedublicate+" Species Name "+speciesnamedublicate+" Bread Name "+breednamedublicate+"<br>"
  
  }
  
  }
  if(result1){
  //Swal.fire("Duplicate Values",result1);
  console.log(result1)
  sweetalert.push(result1)
  }*/
  
  this.exceldublicatevaluecheck(excelFnameSnameAid)
  console.log(this.exceldublicatfunarr);
  var resultanid = "";
  if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
   var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
   var farmnamedublicate=getduplicatevalue[0];
   var speciesnamedublicate=getduplicatevalue[1];
   var animaliddublicate=getduplicatevalue[2];
   //var animaliddublicate=getduplicatevalue[3];
   resultanid +="Animal Id '"+animaliddublicate+"' entered multiple times<br>"
  
  }
  
  }
  if(resultanid){
  //Swal.fire("Duplicate Values",resultanid);
  console.log(resultanid)
  sweetalert.push(resultanid)
  }
  
  this.exceldublicatevaluecheck(excelFnameSnameBnameAId);
  
  console.log(this.exceldublicatfunarr);
  var result2 = "";
  if(this.exceldublicatfunarr){
  for(var i=0;i<this.exceldublicatfunarr.length;i++){
   var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
   var farmnamedublicate=getduplicatevalue[0];
   var speciesnamedublicate=getduplicatevalue[1];
   var breednamedublicate=getduplicatevalue[2];
   var animaliddublicate=getduplicatevalue[3];
   result2 += "Animal Id '"+animaliddublicate+"' entered multiple times<br>"
  }
  
  }
  if(result2){
  //Swal.fire("Duplicate Values",result2);
  console.log(result2);
  sweetalert.push(result2)
  }
  //dublicate species,breeds,fname end
  
  /*//dublicate species,breeds,fname start table
  this.exceldublicatevaluecheckintable(excelFnameSnmeBname,breedfarmname_speciesname_breedname)
  console.log(this.exceldublicatfunarrtable);
  //console.log(uniquerSpeciesformarray);
  var result3 = "";
  if(this.exceldublicatfunarrtable){
  for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
   var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
   var farmnamedublicate2=getduplicatevalue[0];
   var speciesnamedublicate2=getduplicatevalue[1];
   var breednamedublicate2=getduplicatevalue[2];
   //var animaliddublicate2=getduplicatevalue[3];
  result3 += "Animal Id '"+animaliddublicate+"' entered multiple times<br>"
  }
  }
  if(result3){
  //Swal.fire("Duplicate Values",result3);
  console.log(result3)
  sweetalert.push(result3)
  }*/
  
  this.exceldublicatevaluecheckintable(excelFnameSnameAid,farmname_speciesname_animalid)
  console.log(this.exceldublicatfunarrtable);
  var resultanidtable = "";
  if(this.exceldublicatfunarrtable){
  for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
   var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
   var farmnamedublicate=getduplicatevalue[0];
   var speciesnamedublicate=getduplicatevalue[1];
   var animaliddublicate=getduplicatevalue[2];
   //var animaliddublicate=getduplicatevalue[3];
   resultanidtable += "Animal Id '"+animaliddublicate+"' entered multiple times<br>"
  
  }
  
  }
  if(resultanidtable){
  //Swal.fire("Duplicate Values",resultanidtable);
  console.log(resultanidtable)
  sweetalert.push(resultanidtable)
  }
  
  
  this.exceldublicatevaluecheckintable(excelFnameSnameBnameAId,bname_speciesname_aid_fname)
  console.log(this.exceldublicatfunarrtable);
  var result4 = "";
  if(this.exceldublicatfunarrtable){
  for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
   var getduplicatevalue=this.exceldublicatfunarrtable[i].split('_');
   var farmnamedublicate2=getduplicatevalue[0];
   var speciesnamedublicate2=getduplicatevalue[1];
   var breednamedublicate2=getduplicatevalue[2];
   var animaliddublicate2=getduplicatevalue[3];
   if(animaliddublicate2!=undefined){
    result4 +="Animal Id '"+animaliddublicate2+"' entered multiple times<br>"
   }
  }
  }
  if(result4){
   // Swal.fire("Duplicate Values",result4);
    console.log(result4)
    sweetalert.push(result4)
  }
  
  //dublicate species id and breed entry check in list table with farm id end
  var finalvalidatevalue='';
  for(var i=0;i<sweetalert.length;i++){
    finalvalidatevalue+=sweetalert[i]+"<br>";
  }
  if(finalvalidatevalue){
    Swal.fire("Duplicate values",finalvalidatevalue);
    let currentUrl = this.samepageroute;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
  });   
  }else{
    var stockbulkdata=[]
    for(var i=0;i<this.dataString.data.length;i++){
        var updatestatus=this.dataString.data[i].Status.toLowerCase();
        if(updatestatus=="active"){
          this.dataString.data[i].Status = 1
          }else{
          this.dataString.data[i].Status = 0
          }
      var obj =this.dataString.data[i];
      Object.assign(obj, {cby:this.user_id});
      Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
      stockbulkdata.push(obj);
    }
    console.log(stockbulkdata)
     this.addUrl = "/stock_management/bulk"; 
      (await this.commonService.postApi(this.addUrl,stockbulkdata)).subscribe(
        data => {
            this.showUploadSuccessAndReturn(data, this.samepageroute);
        });
       
       
  }
   
   /* this.addUrl = "/species";
  (await this.commonService.postApi(this.addUrl,this.dataString.data)).subscribe(
    data => {
        alert(data.message);
    });*/
  
     // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
     
    }
    reader.readAsBinaryString(file);
  }
  /*async importbulkdatafromexcelforgeneral(ev){
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.farm_userrole=this.loginresponse.user_farm_id;
    this.user_id=this.loginresponse.user_id;
    this.farmcodeforvalidation=this.loginresponse.user_farm_code;
      console.log('test');
      console.log(ev);
      this.getspeciesListData;
      var uniquerSpeciesformarray=[];
      var uniquespeciesarray=[];
      var uniquebreedsarray=[];
      var sweetalert=[];
      var breedfarmname_speciesname_breedname=[];
      var farmname_speciesname_animalid=[];
      var generallistanimalcodetablecheck=[]
      var bname_speciesname_aid_fname=[];
      console.log(this.getstockmanagementListData);
      for(var i=0;i<this.getstockmanagementListData.length;i++){
           var animalcode=String(this.getstockmanagementListData[i].tnsm_animal_code).trim().toLowerCase();
           this.listanimaliduniquecheck.push(animalcode);
             //batchnoduplicatecheck.push(animalcode);
             console.log(animalcode)
      }
      console.log(this.getfarmsListData)
      for(var i=0;i<this.getfarmsListData.length;i++){
        var farmname1=String(this.getfarmsListData[i].tnfr_code).trim().toLowerCase();
          uniquerSpeciesformarray.push(farmname1);
          console.log(uniquerSpeciesformarray)
    }
    for(var i=0;i<this.getspeciesListData.length;i++){
    var speciesname=String(this.getspeciesListData[i].speciesID).trim().toLowerCase();
    uniquespeciesarray.push(speciesname);
      console.log(uniquespeciesarray)
    }
    for(var i=0;i<this.getbreedListData.length;i++){
      var breedname=String(this.getbreedListData[i].breedID).trim().toLowerCase();
      uniquebreedsarray.push(breedname);
        console.log(uniquebreedsarray)
      }
      for(var i=0;i<this.getgenerallistdata.length;i++){
        var generallistanimalcode=String(this.getgenerallistdata [i].tnam_gen_animal_code).trim().toLowerCase();
        generallistanimalcodetablecheck.push(generallistanimalcode);
         console.log(generallistanimalcodetablecheck)
   }
     
    
      let workBook = null;
      let jsonData = null;
      const reader = new FileReader();
      const file = ev.target.files[0];
      reader.onload = async (event) => {
        const data =reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        var uploadexcelarray=Object.values(jsonData)[0];
        this.dataString ={data:uploadexcelarray}
    //        let value:any=dataString;
    console.log(this.dataString);
   var wrongfarmid=[];
        var excelFnameSnmeBname=[];
        var excelFnameSnameAid=[];
        var excelFnameSnameBnameAId=[];
        var excelfarmuniquename=[];
        var excelspeciesuniquename=[];
        var excelbreeduniquename=[];
        var excelanimalcode=[];
        var excelanimalid=[];
        if(this.farm_userrole){
        for(var i=0;i<this.dataString.data.length;i++){
          if (this.dataString.data[i]["Farm id"].trim().toLowerCase() == this.farmcodeforvalidation.trim().toLowerCase()) {
          var farmname=String(this.dataString.data[i]["Farm id"]).trim().toLowerCase();
         var speciesname=String(this.dataString.data[i]["Species id"]).trim().toLowerCase();
         var breedname= String(this.dataString.data[i]["Breed id"]).trim().toLowerCase();
         var animalcode=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase();
          excelFnameSnmeBname.push(farmname+'_'+speciesname+'_'+breedname);
          excelFnameSnameAid.push(farmname+'_'+speciesname+'_'+animalcode);
          excelanimalid.push(animalcode);
          excelFnameSnameBnameAId.push(farmname+'_'+speciesname+'_'+breedname+'_'+animalcode);   
           excelfarmuniquename.push(farmname);
        excelspeciesuniquename.push(speciesname);
        excelbreeduniquename.push(breedname);
        excelanimalcode.push(animalcode);
          }else{
            wrongfarmid.push(this.dataString.data[i].farm_name.trim().toLowerCase())
            console.log( wrongfarmid)
          }
        }
        if(wrongfarmid.length!==0){
          sweetalert.push("Entered Incorrect Farm Id")
        }
      }
       
      if(!this.farm_userrole){
        for(var i=0;i<this.dataString.data.length;i++){
          var farmname=String(this.dataString.data[i]["Farm id"]).trim().toLowerCase();
          var speciesname=String(this.dataString.data[i]["Species id"]).trim().toLowerCase();
          var breedname= String(this.dataString.data[i]["Breed id"]).trim().toLowerCase();
          var animalcode=String(this.dataString.data[i]["Animal code"]).trim().toLowerCase();
           excelFnameSnmeBname.push(farmname+'_'+speciesname+'_'+breedname);
           excelFnameSnameAid.push(farmname+'_'+speciesname+'_'+animalcode);
           excelanimalid.push(animalcode);
           excelFnameSnameBnameAId.push(farmname+'_'+speciesname+'_'+breedname+'_'+animalcode);   
            excelfarmuniquename.push(farmname);
         excelspeciesuniquename.push(speciesname);
         excelbreeduniquename.push(breedname);
         excelanimalcode.push(animalcode);
        }
      }

        //unique farm check start
            console.log(excelFnameSnameBnameAId)
    var differentfarmdata = [];
    
    // var difference = [];
    for( var i = 0; i < excelfarmuniquename.length; i++ ) {
      if( $.inArray( excelfarmuniquename[i], uniquerSpeciesformarray ) == -1 ) {
        differentfarmdata.push(excelfarmuniquename[i]);
        console.log(differentfarmdata)
      }
    }
    
    var result ="";
    if(differentfarmdata){
    for(var i=0;i<differentfarmdata.length;i++){
    result +="Farm Id '"+differentfarmdata[i]+"' doesn't exist<br>"
    console.log(differentfarmdata);
    }
    }
    if(result){
    //Swal.fire("Wrong Farm Selection",result);
    sweetalert.push(result)
    
    }
    //unique farm check end
    //unique species check start
    var differentspeciesdata=[];
    for( var i = 0; i < excelspeciesuniquename.length; i++ ) {
      if( $.inArray( excelspeciesuniquename[i], uniquespeciesarray ) == -1 ) {
        differentspeciesdata.push(excelspeciesuniquename[i]);
        console.log(differentspeciesdata)
      }
    }
    
    var resultspecies ="";
    if(differentspeciesdata){
    for(var i=0;i<differentspeciesdata.length;i++){
    resultspecies += "Species Id '"+differentspeciesdata[i]+"' doesn't exist<br>"
    console.log(differentspeciesdata);
    }
    }
    if(resultspecies){
    //Swal.fire("Wrong Farm Selection",resultspecies);
    sweetalert.push(resultspecies)
    }
    //unique species check end
    //unique breed check start
    var differentbreeddata=[];
    for( var i = 0; i < excelbreeduniquename.length; i++ ) {
      if( $.inArray( excelbreeduniquename[i], uniquebreedsarray ) == -1 ) {
        differentbreeddata.push(excelbreeduniquename[i]);
      }
    }
    console.log(differentbreeddata)
    var resultbreeds ="";
    if(differentbreeddata){
    for(var i=0;i<differentbreeddata.length;i++){
    resultbreeds +="Breed Id '"+differentbreeddata[i]+"' doesn't exist<br>"
    console.log(differentbreeddata);
    }
    }
    if(resultbreeds){
    //Swal.fire("Wrong Farm Selection",resultbreeds);
    sweetalert.push(resultbreeds)
    }
    //unique breed check end
    //unique animal code check start..
    //unique animal code check start.................................
   // excelanimalid.push(animalcode);
    var differentanimaldata = [];
    // var difference = [];
    console.log(excelanimalcode)
    for( var i = 0; i < excelanimalcode.length; i++ ) {
        if( $.inArray( excelanimalcode[i],this.listanimaliduniquecheck ) == -1 ) {
          differentanimaldata.push(excelanimalcode[i]);
          console.log(excelanimalcode[i])
        }
    }
    console.log(differentanimaldata)
    var result ="";
    if(differentanimaldata){
      for(var i=0;i<differentanimaldata.length;i++){
      result +="Animal Id '"+differentanimaldata[i]+"' doesn't exist<br>"
      console.log(differentanimaldata);
    }
    }
    if(result){
     // Swal.fire("Wrong Farm Selection",result);
      sweetalert.push(result)
    }
    //unique animal code end..
    //list animal code dublicate check for general start
    console.log(excelanimalcode)
    this.exceldublicatevaluecheckintable(excelanimalcode,generallistanimalcodetablecheck)
    console.log(this.exceldublicatfunarrtable);
    var result4 = "";
    if(this.exceldublicatfunarrtable){
    for(var i=0;i<this.exceldublicatfunarrtable.length;i++){
     var getduplicatevaluegeneral=this.exceldublicatfunarrtable[i]
    result4 +="This '"+getduplicatevaluegeneral+"' animal code already has general details<br>"
    }
    }
    if(result4){
     // Swal.fire("Duplicate Values",result4);
      console.log(result4)
      sweetalert.push(result4)
    }
        //list animal code dublicate check for general end


    this.exceldublicatevaluecheck(excelFnameSnameBnameAId);
    
    console.log(this.exceldublicatfunarr);
    var result2 = "";
    if(this.exceldublicatfunarr){
    for(var i=0;i<this.exceldublicatfunarr.length;i++){
     var getduplicatevalue=this.exceldublicatfunarr[i].split('_');
     var farmnamedublicate=getduplicatevalue[0];
     var speciesnamedublicate=getduplicatevalue[1];
     var breednamedublicate=getduplicatevalue[2];
     var animaliddublicate=getduplicatevalue[3];
     result2 +="Animal ID '"+animaliddublicate+"' entered multiple times<br>"
     
    }
    
    }
    if(result2){
    //Swal.fire("Duplicate Values",result2);
    console.log(result2);
    sweetalert.push(result2)
    }
    //dublicate species,breeds,fname end
    this.exceldublicatevaluecheck(excelanimalid);
    
    console.log(this.exceldublicatfunarr);
    var resultanimalid = "";
    if(this.exceldublicatfunarr){
    for(var i=0;i<this.exceldublicatfunarr.length;i++){
     var getduplicatevalue=this.exceldublicatfunarr[i];
     //var animalid=getduplicatevalue[0];
     resultanimalid +="Animal ID '"+getduplicatevalue+"' entered multiple times<br>"
    }
    
    }
    if(resultanimalid){
    //Swal.fire("Duplicate Values",result2);
    console.log(resultanimalid);
    sweetalert.push(resultanimalid)
    }
    
    //dublicate species id and breed entry check in list table with farm id end
    var finalvalidatevalue='';
    for(var i=0;i<sweetalert.length;i++){
      finalvalidatevalue+=sweetalert[i]+"<br>";
    }
    if(finalvalidatevalue){
      Swal.fire("Duplicate values",finalvalidatevalue);
      let currentUrl = this.samepagerouteanimal;
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
      }); 
    
    }else{
      var stockbulkdata=[]
      for(var i=0;i<this.dataString.data.length;i++){
        var obj =this.dataString.data[i];
        Object.assign(obj, {cby:this.user_id});
        Object.keys(obj).map(k => obj[k] = typeof obj[k] == 'string' ? obj[k].trim() : obj[k]);
        stockbulkdata.push(obj);
      }
      console.log(stockbulkdata)
       this.addUrl = "/animal_management/general/bulk/creation"; 
        (await this.commonService.postApi(this.addUrl,stockbulkdata)).subscribe(
          data => {
              alert(data.message);
          });
          let currentUrl = this.samepagerouteanimal;
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
              this.router.navigate([currentUrl]);
          }); 
         
         
    }
     
    
    
       // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
       
      }
      reader.readAsBinaryString(file);
    
  }*/
      //bulk upload import data from excel end......................
exceldublicatevaluecheck(excelFnameSnmeBname){
  const arry = excelFnameSnmeBname;
  const toFindDuplicates = arry => arry.filter((item, index) => arry.indexOf(item) !== index)
const duplicateElementa = toFindDuplicates(arry);
this.exceldublicatfunarr = duplicateElementa; 
}   

exceldublicatevaluecheckintable(excelFnameSnmeBname,breedfarmname_specisid_breedname){
  //  console.log(excelFnameSnmeBname)
   // console.log(breedfarmname_specisid_breedname)
    for( var i = 0; i < excelFnameSnmeBname.length; i++ ) {
      if( $.inArray( excelFnameSnmeBname[i], breedfarmname_specisid_breedname ) !== -1 ) {
        this.exceldublicatfunarrtable.push(excelFnameSnmeBname[i]);
      }
    }
  }

 /*var batchnoduplicatecheck=[];
    for(var i=0;i<this.getvaccineListData.length;i++){
         var batchno=this.getvaccineListData[i].tnvc_batch_number;
         this.listbatchno.push(batchno);
           batchnoduplicatecheck.push(batchno);
    }*/
  }

